import { useEffect, useRef } from "react";

import { useAppDispatch, useAppSelector } from "@/reduxHooks";
import { currentUserMetadata } from "@/slices/auth-slice";
import { openModal } from "@/slices/modal-slice/modal-slice";
import { ModalTypes } from "@/slices/modal-slice/modals-constant";
import { FEEDBACK_TYPE } from "@/utils/enums";

export const useFeedbackTimer = () => {
  const dispatch = useAppDispatch();
  const userData = useAppSelector(currentUserMetadata);
  const timerRef = useRef<NodeJS.Timeout>();
  useEffect(() => {
    if (!userData?.requestFeedback) return;

    const expiryDate = new Date(userData.trialUserExpiryDate || "");
    const now = new Date();
    const hoursDiff = (expiryDate.getTime() - now.getTime()) / (1000 * 60 * 60);

    timerRef.current = setTimeout(() => {
      dispatch(
        openModal({
          modalType: ModalTypes.FEEDBACK,
          modalProps: {
            feedbackType:
              hoursDiff <= 24
                ? FEEDBACK_TYPE.TRAIL_ENDING
                : FEEDBACK_TYPE.REQUEST_FEEDBACK,
          },
        })
      );
    }, 30000);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [userData?.requestFeedback, userData?.trialUserExpiryDate, dispatch]);
};
